import { useMemo } from 'react'

function useOfferRating(
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | App.VillaOffer | App.VillaOfferSummary,
  offerListMeta: App.OfferListMetaData | undefined,
  isMetaSearchPage?: boolean,
): App.OfferRating | undefined {
  return useMemo(() => {
    if (offerListMeta?.rating) {
      return {
        score: offerListMeta.rating.score,
        reviewsTotal: offerListMeta.rating.totalReviews,
      } as App.OfferRating
    }

    if (isMetaSearchPage) {
      return {
        score: offer.property.rating?.score,
        reviewsTotal: offer.property.rating?.reviewsTotal,
      } as App.OfferRating
    }

    // Fallback to offer.property.rating when offerListMeta is not available
    // This ensures rating is displayed even when search metadata is incomplete
    if (offer.property.rating?.score !== undefined) {
      return {
        score: offer.property.rating.score,
        reviewsTotal: offer.property.rating.reviewsTotal,
      } as App.OfferRating
    }
  }, [offerListMeta?.rating, isMetaSearchPage, offer.property.rating])
}

export default useOfferRating
